import React from 'react';
import { Input } from 'antd';
import styles from './input.module.scss';

const InputField = ({
  type = 'text',
  placeholder,
  isPassword = false,
  className,
  ...restProps
}) => {
  return (
    <>
      {isPassword ? (
        <Input.Password
          placeholder={placeholder}
          className={`${styles.input} ${className} input `}
          {...restProps}
        />
      ) : (
        <Input
          type={type}
          placeholder={placeholder}
          className={`${styles.input} ${className} input`}
          {...restProps}
        />
      )}
    </>
  );
};

export default InputField;
